import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import MemorialsPage from "@pages/Memorials/MemorialsPage";
import MemorialEditorPage from "@pages/Memorials/MemorialEditorPage";
import GuestBookPage from "@pages/Memorials/GuestBookPage";
import TributeModerationPage from "@pages/Memorials/TributeModerationPage";
import GuestBookModerationPage from "@pages/Memorials/GuestBookModerationPage";
import ServiceSheetPage from "@pages/Memorials/ServiceSheetPage";
import MemorialExportPage from "@pages/Memorials/MemorialExportPage";
import SetAdminPage from "@pages/Memorials/SetAdminPage";
import SetAdminSuccessPage from "@pages/Memorials/SetAdminSuccessPage/SetAdminSuccessPage";
import GalleryEditorPage from "@pages/Memorials/GalleryEditorPage";
import TimelineEditorPage from "@pages/Memorials/TimelineEditorPage";
import { UserType } from "@models/User";
import ProtectedPage from "@components/routes/ProtectedPage";
import PurchaseMemorialPage from "@pages/Account/PurchaseMemorialPage/PurchaseMemorialPage";
import PurchaseCandlePage from "@pages/Account/PurchaseCandlePage/PurchaseCandlePage";
import PurchaseSuccessPage from "@pages/Account/PurchaseSuccessPage/PurchaseSuccessPage";
import { getRegion } from "@util/domain";

const PROTECTED_ROUTE_ROLES: UserType[] = ["root_admin", "business_admin", "demo"];

export default [
    {
        path: "memorials",
        element: <Outlet />,
        children: [
            {
                path: "",
                element: <MemorialsPage />,
            },
            {
                path: "editor",
                element: <MemorialEditorPage />,
            },
            {
                path: "timeline-editor",
                element: <TimelineEditorPage />,
            },
            {
                path: "gallery-editor",
                element: <GalleryEditorPage />,
            },
            {
                path: "guest-book",
                element: <GuestBookPage />,
            },
            {
                path: "guest-book-moderation",
                element: <GuestBookModerationPage />,
            },
            {
                path: "service-sheet",
                element: <ServiceSheetPage />,
            },
            {
                path: "export-pdf",
                element: <MemorialExportPage />,
            },
            {
                path: "tribute-moderation",
                element: <TributeModerationPage />,
            },
            {
                path: "set-admin",
                element: (
                    <ProtectedPage allowedRoles={PROTECTED_ROUTE_ROLES}>
                        <SetAdminPage />
                    </ProtectedPage>
                ),
            },
            {
                path: "set-admin-success",
                element: (
                    <ProtectedPage allowedRoles={PROTECTED_ROUTE_ROLES}>
                        <SetAdminSuccessPage />
                    </ProtectedPage>
                ),
            },
            {
                path: "purchase-memorial",
                element: <PurchaseMemorialPage />,
            },
            {
                path: "purchase-candle",
                // Forever Candles ship within Australia only; International hubs go back to the memorials list
                element: getRegion() === "au" ? <PurchaseCandlePage /> : <Navigate to="/memorials" replace />,
            },
            {
                path: "purchase-success",
                element: <PurchaseSuccessPage />,
            },
        ],
    },
];
